import { Session } from 'next-auth';

type DynamicEnvironmentVariableKeys = 'FEATURES';

export type DynamicEnvironmentVariables = {
  [key in DynamicEnvironmentVariableKeys]?: any;
};

export interface PageBaseProps {
  session: Session;
  dynamicEnvVars: DynamicEnvironmentVariables;
}

let dynamicEnvVariables: DynamicEnvironmentVariables = null;

export function serverEnvironmentVariablesToClientObject(): DynamicEnvironmentVariables {
  return {
    ...(process.env.FEATURES ? { FEATURES: process.env.FEATURES } : {}),
  };
}

/**
 * Handles environment variables passed directly from the server through server-side-rendering.
 * These variables are defined and mapped in `serverEnvironmentVariablesToClientObject`.
 */
export class DynamicEnvironmentVariable {
  /**
   * Gets an environment variable. In server-side code, this call will return the environment variable directly.
   * On client-side, the call will return the value passed in previously through server-side-rendering.
   * @param key The name of the environment variable.
   * @returns The environment variable value.
   */
  public static get(key: DynamicEnvironmentVariableKeys) {
    return (
      (dynamicEnvVariables ? dynamicEnvVariables[key] : undefined) ??
      process.env[key]
    );
  }

  /**
   * Set/update environment variables from SSR.
   */
  public static setFromServerSideRendering(
    variables: DynamicEnvironmentVariables
  ) {
    dynamicEnvVariables = variables;
  }
}
